<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <div class="dispatch-table">
          <b-card>
            <div slot="header">
              <span>Warehouse Activity List</span>
              <a
                href="#"
                class="btn btn-sm btn-info float-right ml-1"
                id="printpagebutton"
                @click="onPrint"
              >
                <i class="fa fa-print"></i> Print
              </a>
              <button
                id="printexport"
                class="btn btn-sm btn-info float-right"
                @click="onexport"
              >
                Export
              </button>
            </div>

            <tr>
              <td>
                <!-- <div class="newButton"> -->
                <b-button
                  variant="primary"
                  @click="
                    $router.push('/Activity/636977057383879632/new-activity')
                  "
                  style="margin-top: -5px"
                >
                  <i class="fa fa-plus-circle"></i>&nbsp;New Warehouse Activity
                </b-button>
                <!-- </div> -->
              </td>
              <td>
                <!-- <b-col md="3" class="my-1"> -->
                <!-- <b-form-group style="margin-left: 10px; margin-bottom: -5px;"> -->
                <b-input-group style="margin-left: 10px; margin-bottom: 10px">
                  <b-form-input v-model="filter" placeholder="Search.." />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
                <!-- </b-form-group> -->
                <!-- </b-col> -->
              </td>
            </tr>

            <b-table
              show-empty
              bordered
              responsive="sm"
              stacked="md"
              hover
              small
              striped
              head-variant="light"
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Edit)="data">
                <b-button
                  size="sm"
                  variant="primary"
                  class="btn btn-primary btn-sm mb-1"
                  @click="editwhs(data.item.seqid, data.item)"
                >
                  Edit</b-button
                >&nbsp;
              </template>
              <template v-slot:cell(Tag)="data">
                <b-button
                  size="sm"
                  variant="primary"
                  class="btn btn-primary btn-sm mb-1"
                  @click="onTagFleet(data.item)"
                >
                  TagFleet</b-button
                > 
              </template>
              <template v-slot:cell(View)="data">
                <b-button
                  size="sm"
                  variant="success"
                  class="btn btn-sm mb-1"
                  @click="viewCard(data.item.seqid)"
                  >View Card
                </b-button>
              </template>
              <template slot="isactive" slot-scope="data">
                <i
                  :class="
                    data.item.isactive == 1
                      ? 'activeStatus icon-check active_icon'
                      : 'inactiveStatus icon-close inactive_icon'
                  "
                ></i>
              </template>
            </b-table>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              >
              </b-pagination>
            </div>
          </b-card>
        </div>

        <b-modal title="Tag Fleet" v-model="TagFleetModal" @ok="onAddFleet">
          <form class="form">
            <div style="height: 50vh; overflow-x: auto">
              <input
                type="text"
                class="form-control mb-2"
                v-model="SearchFleet"
                placeholder="Search Plate no"
              />
              <span v-if="filterfleet.length == 0">No available Fleet.</span>
              <b-list-group-item
                v-for="item in filterfleet"
                :key="item.licenseno"
              >
                <b-form-radio
                  v-model="LaneModel"
                  name="some-radios"
                  :value="item"
                  @change="SelectFleet"
                >
                  <span class="mr-2"
                    >FleetID:&nbsp;{{ item.fleetregistryId }}</span
                  >
                  <span class="mr-2">Plate no.&nbsp;{{ item.plateno }}</span>
                  <span class="mr-2"
                    >License no:&nbsp;{{ item.licenseno }}</span
                  >
                </b-form-radio>
              </b-list-group-item>
            </div>
          </form>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "../../../services/api";
import JSONToCSVConvertor from "../../../services/JSONToCSVConvertor.js";
import miniToastr from "mini-toastr";
import axios from "axios";
export default {
  data: function () {
    return {
      TagFleetModal: false,
      SearchFleet: "",
      selectedItem: {},
      selectedItemLabel: "",
      perPage: this.$store.getters.perPage,
      currentPage: 1,
      isBusy: false,
      filter: "",
      sortOptions: [],
      fleetList: [],
      LaneModel: "",
      fields: [
        {
          key: "Edit",
          sortable: false,
        },
        {
          key: "Tag",
          sortable: false,
        },
        {
          key: "View",
          sortable: false,
        },
        {
          key: "seqid",
          label: "Sequence ID",
          thClass: ["width-100"],
          sortable: true,
        },
        {
          key: "custcode",
          label: "CustomerCode",
          thClass: ["width-150"],
          sortable: true,
        },
        {
          key: "shipmentno",
          label: "Shipment ID",
          sortable: false,
        },
        {
          key: "picklistno",
          Label: "Picklist ID",
          sortable: true,
        },
        {
          key: "requestno",
          label: "Rquest ID",
          sortable: false,
        },
           {
          key: "deliverydate",
          label: "Delivery Date",
          sortable: false,
        },
        {
          key: "remarks",
          label: "Remarks",
        },
        // {
        //   key: "ownername",
        //   label: "Trucker"
        // },
        // {
        //   key: "plateno",
        //   label: "Plate No"
        // }
      ],
      items: [],
      form: {
        seqid: "",
        custcode: "",
        remarks: "",
        shipmentno: "",
        picklistno: "",
        requestno: "",
        fleetregistryId: "",
        createby:
          this.$store.getters.user.firstname +
          " " +
          this.$store.getters.user.lastname,
        createdate: "",
      },
    };
  },
  computed: {
    filterfleet: function () {
      var self = this;
      return this.fleetList.filter(function (cust) {
        return (
          cust.plateno.toLowerCase().indexOf(self.SearchFleet.toLowerCase()) >=
          0
        );
      });
    },

    filter() {
      this.currentPage = 1;
      this.totalrows = this.items.length;
    },

    rows() {
      return this.items.length;
    },
  },
  methods: {
    onPrint: function () {
      // this.isHidden = true;
      var printButton = document.getElementById("printpagebutton");
      var printExport = document.getElementById("printexport");
      var breadView = document.getElementById("breadview");
      //Set the print button visibility to 'hidden'
      printButton.style.visibility = "hidden";
      printExport.style.visibility = "hidden";
      breadView.style.visibility = "hidden";
      //Print the page content
      window.print();
      printButton.style.visibility = "visible";
      printExport.style.visibility = "visible";
      breadView.style.visibility = "visible";
    },

    onexport: function () {
      JSONToCSVConvertor(this.items, "Warehouse Activity List", true);
    },

    initTable() {
      this.isBusy = true;
      let self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-whseactivity-list?brancode=" +
            self.$store.getters.selectedWarehouse
        )
        .then((resp) => {
          self.items = resp.data;
          self.$store.commit("setLoading", false);
          self.isBusy = false;
        })
        .catch((err) => {
          self.isBusy = false;
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);

          return [];
        });
    },

    onTagFleet: function (param) {
      let self = this;
      self.$store.commit("setLoading", true);
      self.selectedItem = param;
      self.selectedItemLabel = self.selectedItem.seqid;
      self.form.seqid = self.selectedItem.seqid;
      self.form.fleetregistryId = self.selectedItem.fleetregistryId;
      self.fleetList = [];
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-fleetregistry?brancode=" +
            self.$store.getters.selectedWarehouse
        )
        .then((resp) => {
          resp.data.forEach((element) => {
            self.fleetList.push({
              fleetregistryId: element.fleetregistryId,
              brancode: element.brancode,
              plateno: element.plateno,
              licenseno: element.licenseno,
              regtype: element.regtype,
              scancode: element.scancode,
              refdocument: element.refdocument,
            });
          });

          self.$store.commit("setLoading", false);

          self.TagFleetModal = true;

          console.log(resp.data);
        });
      // .catch(function (err) {
      //   self.$store.commit("setLoading", false);
      //   api.httpMsg(self, err.status, err.data);
      // });
    },

    SelectFleet: function (param) {
      this.form.fleetregistryId = param.fleetregistryId;
    },

    onAddFleet: function () {
      this.$store.commit("setLoading", true);
      api.instance
        .put(
          this.$store.state.IFMSURLlocal + "update-warehouse-fleetregid",
          this.form
        )
        .then((resp) => {
          this.initTable();
          this.TagFleetModal = false;
          miniToastr.success("Fleet Successfully Added");
          this.$store.commit("setLoading", false);
        })
        .catch((err) => {
          this.$store.commit("setLoading", false);
          api.httpMsg(this, err.status, err.data);
        });
    },

    viewCard: function (seqId) {
      this.$store.state.seqId = seqId;
      this.$router.push("/Activity/636977057383879632/sqid/" + seqId);
    },

    editwhs(seqId, item) {
      this.$store.state.seqId = seqId;
      this.$store.state.testitem = item;
      this.$router.push("/Activity/636977057383879632/modify/" + seqId)
    }
  },
  created: function () {
    this.initTable();
  },
};
</script>
<style scoped>
.nameOfTheClass {
  max-width: 300px;
}
</style>